import { InputGroup, SearchIcon } from '@allurion/ui';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { TrackedPageHeader } from 'src/analytics/TrackedUI';
import { Seo } from 'src/components/Seo';
import { parseClinicsData } from 'src/domain/Clinic';
import { useAppNavigate } from 'src/hooks/useAppNavigate';
import { useClinic } from 'src/hooks/useClinic';
import { useDebounceCallback } from 'src/hooks/useDebounceCallback';

import { ManageUsersTable } from '../ManageUsers/ManageUsersTable';

import styles from './ClinicProvidersPage.module.scss';

export function ClinicProvidersPage() {
  const intl = useIntl();
  const { clinicId } = useParams();
  const { clinic } = useClinic(clinicId);
  const { toInviteProviderPage, toEditProviderPage, navigateAndScrollToTop } = useAppNavigate();
  const [search, setSearch] = useState('');

  const clinics = clinic ? parseClinicsData([clinic]) : [];

  const debouncedHandleSearchInput = useDebounceCallback(handleSearchInput, 1000);

  return (
    <>
      <Seo title="Clinic Members" />
      <TrackedPageHeader
        title={intl.formatMessage({
          id: 'clinic-providers.header',
          description: 'Clinic Providers page header',
          defaultMessage: 'Clinic members',
        })}
        button={{
          label: intl.formatMessage({
            id: 'clinic-providers.invite-btn',
            defaultMessage: 'Invite member',
          }),
          onClick() {
            toInviteProviderPage(clinicId!);
          },
          trackLabel: 'invite-provider',
        }}
      />
      <div className={styles.container}>
        <InputGroup
          sufix={<SearchIcon />}
          textInput={{
            type: 'text',
            placeholder: intl.formatMessage({
              id: 'clinics-members-page.provider-search',
              defaultMessage: 'Search by name, surname or email',
            }),
            onChange: debouncedHandleSearchInput,
          }}
        />
        <ManageUsersTable
          search={search}
          clinics={clinics}
          onRowClick={(providerId, options) => toEditProviderPage(clinicId!, providerId, options)}
          onResendInviteClick={(options) => navigateAndScrollToTop('./resend-invitation', options)}
        />
      </div>
    </>
  );

  function handleSearchInput(evt: any) {
    setSearch(evt.target.value);
  }
}
